export class LocationFields {
   constructor(public longitude: number, public latitude: number) { }
}